// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__1DcAB","errorLogs":"EditorFooter_errorLogs__2GxwO"};